import VueTypes, { bool, nullable } from 'vue-types';

const itemTypes = ['link', 'image', 'tagLink', 'html', 'text', 'enumIcons' ]

const columnItemSubItemStructure = VueTypes.shape({
    id: VueTypes.oneOfType([Number, nullable]).def(null),
    image: VueTypes.oneOfType([String, nullable]).def(null),
    local: VueTypes.bool.def(false),
    order: VueTypes.oneOfType([Number, nullable]).def(null),
    link:  VueTypes.oneOfType([String, nullable]).def(null),
    label: VueTypes.oneOfType([String, nullable]).def(null)
})

export const columnItemStructure = VueTypes.shape({
    id: VueTypes.oneOfType([Number, nullable]).def(null),
    label: VueTypes.oneOfType([String, nullable]).def(null),
    type: VueTypes.oneOf(itemTypes).isRequired,
    link: VueTypes.oneOfType([String, nullable]).def(null),
    image: VueTypes.oneOfType([String, nullable]).def(null),
    subItems: VueTypes.arrayOf(columnItemSubItemStructure).def(null),
    html: VueTypes.oneOfType([String, nullable]).def(null),
    classes: VueTypes.oneOfType([String, nullable]).def(null),
}).isRequired;

export const columnStructure = VueTypes.shape({
    title: VueTypes.oneOfType([String, nullable]).def(null),
    items: VueTypes.arrayOf(columnItemStructure).def(null),
}).isRequired;


